import { render, staticRenderFns } from "./mod-03.vue?vue&type=template&id=1f588b1e&scoped=true&"
import script from "./mod-03.vue?vue&type=script&lang=js&"
export * from "./mod-03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f588b1e",
  null
  
)

export default component.exports